import { Liquid } from 'liquidjs';
import { canvasHtml } from '~/transformations/CanvasHtml';
import { tryParse } from '~/util/tryparse';

const engine = new Liquid();

// custom random number filter taking a source number as minimum and
// an optional to number as maximum and returns a random number in that range
engine.registerFilter('random', (val: number, to = 1000) => {
  const length = to - val + 1;
  const value = val + Math.floor(length * Math.random());
  return value;
});

// Liquid cannot handle creation of objects in templates so this
// filter allows a capture to be read and parsed back as an object within templates
engine.registerFilter('from_json', (json) => tryParse(json));

engine.registerFilter('html_encode', canvasHtml.encode);

engine.registerFilter('canvas_component', canvasHtml.component);

engine.registerFilter('canvas_entry', canvasHtml.entry);

engine.registerFilter('canvas_image', canvasHtml.image);

// Best-effort HTML -> canvas conversion inside templates. The parser is
// injected via template variables by the caller (see CopyFieldService.ApplyTemplate)
// and is bound to the outer target canvas field's config — so allowedTypes on any
// nested canvas destination are not enforced by this filter.
engine.registerFilter('html_to_canvas', async function (html: string) {
  const parser = (this.context.environments as any)?.__htmlToCanvasParser;
  return parser && html ? await parser(html) : html;
});

export const liquidEngine = engine;
